import { render, staticRenderFns } from "./ChiusuraMassivaFasi.vue?vue&type=template&id=016f26ca&scoped=true&"
import script from "./ChiusuraMassivaFasi.vue?vue&type=script&lang=js&"
export * from "./ChiusuraMassivaFasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016f26ca",
  null
  
)

export default component.exports